<template>
  <div>
    <div class="item-head">
      <span class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill badge-light">{{ item.id }}</span>
      <label class="mini-check"><input :id="`secure-${item.id}`" type="checkbox" v-model="item.security"> محافظت</label>
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان">
      <b-icon class="bg-danger p-1 rounded-pill text-white" icon="trash" @click="deleteQuestion()"/>
    </div>
    <p class="hint">کلید API را در تنظیمات وب‌سایت قرار دهید.</p>
  </div>
</template>

<script>
export default {
  name: "AuthenticatePhoneMeliCodeInput",
  props: {item: {}},
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>
.item-head { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.item-head .form-control { flex: 0 0 200px; }
.mini-check { font-size: 12px; margin: 0; }
.hint { font-size: 12px; color: #6b7280; margin: 8px 0 0; }
</style>
